exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3sbTTGfWsUjDKK7cBgXzGL{display:-webkit-box;display:-ms-flexbox;display:flex}html[dir] ._1gPydoREhWiwSHSum9SlEB{background:\"[theme:white, default:#ffffff]\"}._1gPydoREhWiwSHSum9SlEB._3LKAalxjbAiONa_fGaZ0fc,._1gPydoREhWiwSHSum9SlEB._2Y6VUDBMALD3KTBoIOIShn{height:36px}._1gPydoREhWiwSHSum9SlEB._3Vb0OATwgYYrIlyuN3dNVO{height:32px}html[dir] .usu9PDhBHQDKVwbs3xwVw._3LKAalxjbAiONa_fGaZ0fc{padding-top:8px}html[dir] .usu9PDhBHQDKVwbs3xwVw._3Vb0OATwgYYrIlyuN3dNVO,html[dir] .usu9PDhBHQDKVwbs3xwVw._2Y6VUDBMALD3KTBoIOIShn{padding-top:6px}html[dir] .S_RlW8gHiQRIfvVMUNdF_._3LKAalxjbAiONa_fGaZ0fc{padding-top:4px}", ""]);
// Exports
exports.locals = {
	"shimmerRow": "_3sbTTGfWsUjDKK7cBgXzGL",
	"mailListShimmerContainer": "_1gPydoREhWiwSHSum9SlEB",
	"full": "_3LKAalxjbAiONa_fGaZ0fc",
	"medium": "_2Y6VUDBMALD3KTBoIOIShn",
	"compact": "_3Vb0OATwgYYrIlyuN3dNVO",
	"paddingFirstMessage": "usu9PDhBHQDKVwbs3xwVw",
	"paddingMessage": "S_RlW8gHiQRIfvVMUNdF_"
};